<template>
  <div>
    <div
      style="
        align-items: center;
        display: flex;
        justify-content: center;
        color: gray;
        font-size: small;
      "
    >
      Content is automatically generated by AI and it may contain innacuracy
    </div>
    <div class="message-input">
      <div class="input-wrapper">
        <input
          ref="messageInput"
          class="custom-input"
          type="text"
          placeholder="Type your message..."
          v-model="newMessage"
          @keyup.enter="send"
        />

        <div class="icon-container">
          <b-icon
            icon="arrow-right"
            size="is-medium"
            class="icon-button send"
            title="Send"
            @click.native="send"
          />

          <div v-if="showRegenerate" class="icon-divider"></div>

          <b-icon
            v-if="showRegenerate"
            icon="refresh"
            size="is-medium"
            class="icon-button regenerate"
            :class="{ disabled: disableRegenerate }"
            :title="disableRegenerate ? 'Please wait...' : 'Regenerate'"
            @click.native="onRegenerateClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showRegenerate: {
      type: Boolean,
      default: false,
    },
    disableRegenerate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newMessage: '',
    };
  },
  methods: {
    send() {
      if (!this.newMessage.trim()) return;
      this.$emit('send', this.newMessage.trim());
      this.newMessage = '';
      if (this.$refs.messageInput) {
        this.$refs.messageInput.blur();
      }
    },
    onRegenerateClick() {
      if (this.disableRegenerate) return;
      this.$emit('regenerate');
    },
  },
};
</script>

<style scoped>
.message-input {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.custom-input {
  width: 100%;
  padding: 10px 120px 10px 10px; /* leave space for icon-container */
  font-size: 1rem;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  outline: none;
}

/* New icon wrapper */
.icon-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  gap: 10px;
}

.icon-button {
  cursor: pointer;
  transition: color 0.2s ease;
  color: #555;
}

.icon-button:hover {
  color: #000;
}

.icon-button.regenerate {
  color: rebeccapurple;
}

.icon-button.regenerate:hover {
  color: #4b0082;
}

.icon-divider {
  width: 1.5px;
  height: 28px;
  background-color: #ccc;
}

.icon-button.disabled {
  color: #ccc !important;
  cursor: not-allowed;
  pointer-events: none;
}

.icon-button:hover {
  transform: scale(1.1);
  opacity: 0.85;
}
</style>
